export const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: Number.parseInt(result[1], 16),
            g: Number.parseInt(result[2], 16),
            b: Number.parseInt(result[3], 16)
        }
        : { r: 0, g: 0, b: 0 };
};
export const rgbToHex = (r, g, b) => {
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
export const rgbToHsv = (r, g, b) => {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const diff = max - min;
    let h = 0;
    const s = max === 0 ? 0 : (diff / max) * 100;
    const v = max * 100;
    if (diff !== 0) {
        switch (max) {
            case r:
                h = ((g - b) / diff + (g < b ? 6 : 0)) * 60;
                break;
            case g:
                h = ((b - r) / diff + 2) * 60;
                break;
            case b:
                h = ((r - g) / diff + 4) * 60;
                break;
        }
    }
    return { h: Math.round(h), s: Math.round(s), v: Math.round(v) };
};
export const hsvToRgb = (h, s, v) => {
    s /= 100;
    v /= 100;
    const c = v * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = v - c;
    let r = 0, g = 0, b = 0;
    if (h >= 0 && h < 60) {
        r = c;
        g = x;
    }
    else if (h >= 60 && h < 120) {
        r = x;
        g = c;
    }
    else if (h >= 120 && h < 180) {
        g = c;
        b = x;
    }
    else if (h >= 180 && h < 240) {
        g = x;
        b = c;
    }
    else if (h >= 240 && h < 300) {
        r = x;
        b = c;
    }
    else if (h >= 300 && h < 360) {
        r = c;
        b = x;
    }
    return {
        r: Math.round((r + m) * 255),
        g: Math.round((g + m) * 255),
        b: Math.round((b + m) * 255)
    };
};
export const getHueColor = (hue) => {
    const rgb = hsvToRgb(hue, 100, 100);
    return rgbToHex(rgb.r, rgb.g, rgb.b);
};
